import { render, staticRenderFns } from "./AyudaTemaExpedientes.vue?vue&type=template&id=4440fbe6"
import script from "./AyudaTemaExpedientes.vue?vue&type=script&lang=js"
export * from "./AyudaTemaExpedientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports